export function token (state) {
  return state.token
}
export function d4HToken (state) {
  return state.d4HToken
}

export function user (state) {
  return state.user
}

export function authorities (state) {
  return state.user?.authorities
}

export function loggedIn (state) {
  return state.token !== null
}

export function loggedInD4HToken (state) {
  return state.d4HToken !== null
}

export function hasAuthority (state, getters) {
  return (authority) => {
    const authorities = getters.authorities;
    return authorities && authorities.includes(authority);
  }
}
